<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.tours') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <i class="fa fa-shield"></i>
          <span>{{ $ml.get('shared.guardTourSystem') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.tours') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{ $ml.get('shared.tours') }}</span>
              </h3>
              <div class="box-tools pull-right">
                <button type="button" class="btn btn-sm btn-warning " @click="newGuardTour()">Yeni Tur</button>
              </div>
            </div>
            <div class="box-body">
              <input type="text" :placeholder="$ml.get('general.search')" v-model="searchText" class="form-control"
                style="margin-bottom:10px;" autocomplete="false" />
              <div v-show="guardTourList.length > 0" class="table-responsive no-padding" :style="windowHeightSize">
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="tour in guardTourList" :key="tour.id">
                      <td>{{ tour.name }}</td>
                      <td class="pull-right">
                        <button type="button" class="btn btn-primary btn-sm" @click="getGuardTour(tour.id)">
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="guardTourList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{ $ml.get('users.userNotRecord') }}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>Tur Bilgileri</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <div class="form-group">
                <label>Tur Adı</label>
                <input v-model="guardTour.name" type="text" class="form-control" />
              </div>
              <div class="form-group">
                <label>Başlangıç Zamanı</label>
                <input v-model="guardTour.startDate" type="time" class="form-control" />
              </div>
              <div class="form-group">
                <label>Bitiş Zamanı</label>
                <input v-model="guardTour.endDate" type="time" class="form-control" />
              </div>
            </div>
            <div class="overlay" :hidden="!isLoadingDetail">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-footer">
              <div class="pull-right">
                <button v-show="!isNewGuardTour" type="button" data-toggle="modal" data-target="#modal-sil"
                  class="btn btn-sm btn-danger "
                  style="margin: 5px; width:120px;">{{ $ml.get('general.delete') }}</button>
                <button v-show="isNewGuardTour" type="button" data-toggle="modal" data-target="#modal-kaydet"
                  class="btn btn-sm btn-success " style="margin: 5px; width:120px;">{{ $ml.get('general.save') }}</button>
                <button v-show="!isNewGuardTour" type="button" data-toggle="modal" data-target="#modal-guncelle"
                  class="btn btn-sm btn-success "
                  style="margin: 5px; width:120px;">{{ $ml.get('general.update') }}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>Tur Detayları</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <ul class="products-list product-list-in-box" :style="windowHeightSize">
                <li v-for="detail in tourDetailList" :key="detail.id" class="item" style="cursor:pointer;"
                  @click="selectTourDetail(detail)">
                  <div class="product-img">
                    <img
                      :src="getAreaImageFromId(detail.controlPoint.areaId) ? '/src/assets/buildings/' + getAreaImageFromId(detail.controlPoint.areaId) : '/src/assets/buildings/office-building-19.png'" />
                  </div>
                  <div class="product-info">
                    <span class="product-title">
                      {{ detail.controlPoint.name }}
                      <span class="label label-warning pull-right" style="font-size: large;">{{ detail.time }}</span>
                    </span>
                    <span class="product-description">{{ getAreaNameFromId(detail.controlPoint.areaId) }}</span>
                  </div>
                </li>
                <!-- /.item -->
              </ul>
              <button v-show="!isNewGuardTour" @click="newTourDetail()" class="btn btn-warning btn-lg"
                style="width:100%;">
                <i class="fa fa-plus"></i> Yeni Ekle
              </button>
              <div v-show="isNewGuardTour" class="callout callout-info">
                <i class="fa fa-info-circle"></i> Lütfen önce tur seçin veya tur kaydedin.
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.update') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ guardTour.name }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('users.isContinueUserUpdate') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveGuardTour()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.save') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{ guardTour.name }}</p>
              <span>Yeni tur kaydedilecektir. Devam edilsin mi?</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveGuardTour()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{ $ml.get('general.save') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.delete') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ guardTour.name }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('users.isContinueUserDelete') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click.prevent="deleteGuardTour()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{ $ml.get('general.delete') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal fade" id="modal-tour-detail">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>Tur Kontrol Noktası Detayı</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group" style="margin-top:10px;">
                    <label>
                      <i class="fa fa-clock-o"></i> Zaman
                    </label>
                    <input type="time" class="form-control" v-model="tourDetail.time" />
                  </div>
                  <div v-show="!isNewTourDetail" class="form-group" style="margin-top:10px;">
                    <label>
                      <i class="fa fa-thumb-tack"></i> Kontrol Noktası
                    </label>
                    <select @change="changeControlPoint($event)" class="form-control">
                      <option value>{{ $ml.get('general.select') }}</option>
                      <option v-for="controlPoint in controlPointList" :key="controlPoint.id" :value="controlPoint.id"
                        :selected="tourDetail.guardControlPointId == controlPoint.id">{{ controlPoint.name }}</option>
                    </select>
                  </div>
                  <div v-show="isNewTourDetail">
                    <label>
                      <i class="fa fa-thumb-tack"></i> Kontrol Noktaları
                    </label>
                    <div class="table-responsive" style="max-height:470px;owerflow:auto;">
                      <span class="form-control checkbox" style="margin-bottom:10px;" v-for="controlPoint in controlPointList"
                        :key="controlPoint.id">
                        <label style="margin-left:20px;">
                          <input :checked="controlPoint.isCheck"
                            @change="controlPoint.isCheck == true ? controlPoint.isCheck = false : controlPoint.isCheck = true"
                            type="checkbox" />
                          {{ controlPoint.name }} ({{ getAreaById(controlPoint.areaId) }})
                        </label>
                      </span>
                      <div class="callout callout-warning" v-show="controlPointList.length == 0">Kontrol noktası
                        bulunamadı...</div>
                    </div>
                  </div>
                  <div v-show="tourDetail.controlPoint.areaId && !isNewTourDetail" class="row">
                    <div class="col-sm-2">
                      <img style="width:50px;"
                        :src="getAreaImageFromId(tourDetail.controlPoint.areaId) ? '/src/assets/buildings/' + getAreaImageFromId(tourDetail.controlPoint.areaId) : '/src/assets/buildings/office-building-19.png'" />
                    </div>
                    <div class="col-sm-10">
                      <h4>{{ getAreaNameFromId(tourDetail.controlPoint.areaId) }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="pull-left">
                <button type="button" class="btn btn-secondary"
                  data-dismiss="modal">{{ $ml.get('general.cancel') }}</button>
              </div>
              <div class="pull-right">
                <button data-dismiss="modal" v-show="!isNewTourDetail" @click="deleteTourDetail()"
                  class="btn btn-danger ">
                  <i class="fa fa-trash"></i>
                  {{ $ml.get('general.delete') }}
                </button>
                <button data-dismiss="modal" v-show="!isNewTourDetail" @click="saveTourDetail()"
                  class="btn btn-success ">
                  <i class="fa fa-refresh"></i>
                  {{ $ml.get('general.update') }}
                </button>
                <button data-dismiss="modal" v-show="isNewTourDetail" @click="saveTourDetail()"
                  class="btn btn-success ">
                  <i class="fa fa-check"></i>
                  {{ $ml.get('general.save') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
    </section>
  </div>
</template>
<script>
import alertify from 'alertifyjs';

export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      guardTour: {
        id: 1,
        name: "",
        startDate: "00:00",
        endDate: "00:00"
      },
      tourDetails: [],
      isNewGuardTour: true,
      guardTours: [],
      areas: [],
      controlPoints: [],
      isNewTourDetail: true,
      controlPointIds: [],
      tourDetail: {
        id: null,
        guardTourId: null,
        guardControlPointId: null,
        time: "00:00",
        controlPoint: {
          areaId: null,
          name: ""
        }
      }
    };
  },
  filters: {
    toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      str = new Date(str);
      var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
      var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
      var yil = str.getFullYear();
      var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
      var dakika =
        str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
      var saniye =
        str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
      if (format == "gg.aa.yyyy.ss:dd") {
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    authControl() {
      return this.$store.getters.getAuthBekciTur;
    },
    modules() {
      return this.$store.getters.getModules;
    },
    guardTourList() {
      if (this.searchText) {
        return this.guardTours.filter(item => {
          return this.searchText
            .toUpperCase()
            .split(" ")
            .every(v => item.name.toUpperCase().includes(v));
        });
      } else {
        return this.guardTours;
      }
    },
    areaList() {
      return this.areas;
    },
    controlPointList() {
      return this.controlPoints;
    },
    tourDetailList() {
      return this.tourDetails.sort((a, b) => {
        if (a.time < b.time) return -1;
        if (a.time > b.time) return 0;
      });
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    getAreaById(areaId) {
      var area = this.areaList.filter(a => {
        return a.id == areaId;
      });
      if (area[0]) {
        return area[0].areaName;
      } else {
        return "";
      }
    },
    changeControlPoint(event) {
      this.tourDetail.guardControlPointId = event.target.value;
      var controlPoint = this.controlPointList.filter(a => {
        return a.id == event.target.value;
      });
      if (controlPoint[0]) {
        this.tourDetail.controlPoint = controlPoint[0];
      } else {
        this.tourDetail.controlPoint = {
          areaId: null,
          name: ""
        };
      }
    },
    getAreaNameFromId(areaId) {
      var area = this.areaList.filter(a => {
        return a.id == areaId;
      });
      if (area[0]) {
        return area[0].areaName;
      } else {
        return "";
      }
    },
    getAreaImageFromId(areaId) {
      var area = this.areaList.filter(a => {
        return a.id == areaId;
      });
      if (area[0]) {
        return area[0].imagePath;
      } else {
        return "office-building-19.png";
      }
    },
    newGuardTour() {
      this.isLoadingDetail = true;
      this.isNewGuardTour = true;
      this.guardTour.id = null;
      this.guardTour.name = "";
      this.guardTour.startDate = null;
      this.guardTour.endDate = null;
      this.tourDetails = [];
      this.isLoadingDetail = false;
    },
    async deleteGuardTour() {
      if (this.guardTour.id == null) {
        alertify.warning("Lütfen önce tur seçin...");
        return;
      }
      try {
        this.isLoadingDetail = true;
        let id = this.guardTour.id;
        const response = await this.$axios
          .delete("/GuardTour/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getGuardTours();
        this.newGuardTour();
        alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async saveGuardTour() {
      if (this.guardTour.name == "") {
        alertify.warning("Lütfen tur adı girin...");
        return;
      }
      if (this.guardTour.endDate <= this.guardTour.startDate) {
        alertify.warning("Başlangıç saati bitiş saatinden büyük olamaz");
        return;
      }
      this.isLoadingDetail = true;
      if (this.isNewGuardTour) {
        try {
          let guardTour2 = this.guardTour;
          const response = await this.$axios
            .post("/GuardTour", {
              name: guardTour2.name,
              startDate: guardTour2.startDate,
              endDate: guardTour2.endDate
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          var id = response.data.id;
          try {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
            } else {
              alertify.error(response.message);
            }
          } catch (error) { }
          this.getGuardTours();
          this.getGuardTour(id);
          this.isNewGuardTour = false;
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let guardTour2 = this.guardTour;
          const response = await this.$axios
            .put("/GuardTour/" + guardTour2.id, {
              name: guardTour2.name,
              startDate: guardTour2.startDate,
              endDate: guardTour2.endDate
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          try {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
            } else {
              alertify.error(response.message);
            }
          } catch (error) { }
          this.getGuardTours();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    async getGuardTour(id) {
      try {
        this.isLoadingDetail = true;
        this.newGuardTour();
        const response = await this.$axios
          .get("/GuardTour/" + id)
          .then(response => {
            this.isNewGuardTour = false;
            this.guardTour.id = id;
            this.guardTour.name = response.data.name;
            this.guardTour.startDate = response.data.startDate
              ? this.toDateFormat(response.data.startDate, "ss:dd")
              : "";
            this.guardTour.endDate = response.data.endDate
              ? this.toDateFormat(response.data.endDate, "ss:dd")
              : "";
            this.getTourDetails(id);
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    newTourDetail() {
      this.isNewTourDetail = true;
      this.tourDetail.id = null;
      this.tourDetail.guardTourId = this.guardTour.id;
      this.tourDetail.guardControlPointId = null;
      this.tourDetail.time = this.guardTour.startDate;
      this.tourDetail.controlPoint = {
        areaId: null,
        name: ""
      };
      this.controlPointIds = [];
      this.controlPoints.forEach(a => {
        a.isCheck = false;
      });
      $("#modal-tour-detail").modal("show");
    },
    selectTourDetail(tourDetail) {
      this.isNewTourDetail = false;
      this.tourDetail.id = tourDetail.id;
      this.tourDetail.guardTourId = tourDetail.guardTourId;
      this.tourDetail.guardControlPointId = tourDetail.guardControlPointId;
      this.tourDetail.time = tourDetail.time;
      this.tourDetail.controlPoint = tourDetail.controlPoint;
      $("#modal-tour-detail").modal("show");
    },
    async deleteTourDetail() {
      if (this.tourDetail.id == null) {
        alertify.warning("Lütfen önce tur geçiş noktası seçin...");
        return;
      }
      try {
        this.isLoadingDetail = true;
        let id = this.tourDetail.id;
        const response = await this.$axios
          .delete("/GuardTour/TourDetails/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getTourDetails(this.guardTour.id);
        alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async isCheckSelectedControlPoints() {
      this.controlPointIds = [];
      await this.controlPointList.forEach(element => {
        if (element.isCheck == true) {
          this.controlPointIds.push(element.id);
        }
      });
    },
    async saveTourDetail() {
      if (this.guardTour.id == null) {
        alertify.warning("Lütfen önce tur seçin...");
        return;
      }
      if (this.tourDetail.time == "") {
        alertify.warning("Lütfen zaman girin...");
        return;
      }
      if (this.tourDetail.time < this.guardTour.startDate || this.tourDetail.time > this.guardTour.endDate) {
        alertify.warning("Lütfen " + this.toDateFormat(this.guardTour.startDate, 'ss:dd') + "-" + this.toDateFormat(this.guardTour.endDate, 'ss:dd') + " tur saatleri içerisinde bir zaman seçin");
        return;
      }
      this.isLoadingDetail = true;
      if (this.isNewTourDetail) {
        try {
          await this.isCheckSelectedControlPoints();
          if (this.controlPointIds.length == 0) {
            alertify.warning("Lütfen kontrol noktası seçin...");
            return;
          }
          let tourDetail2 = this.tourDetail;
          const response = await this.$axios
            .post("/GuardTour/TourDetails", {
              guardTourId: this.guardTour.id,
              guardControlPointId: this.controlPointIds,
              time: tourDetail2.time
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          try {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
            } else {
              alertify.error(response.message);
            }
          } catch (error) { }
          this.getTourDetails(this.guardTour.id);
          this.isNewTourDetail = false;
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        if (
          this.tourDetail.guardControlPointId == null ||
          this.tourDetail.guardControlPointId == ""
        ) {
          alertify.warning("Lütfen kontrol noktası seçin...");
          return;
        }
        try {
          let tourDetail2 = this.tourDetail;
          const response = await this.$axios
            .put("/GuardTour/TourDetails/" + tourDetail2.id, {
              guardTourId: this.guardTour.id,
              guardControlPointId: tourDetail2.guardControlPointId,
              time: tourDetail2.time
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          try {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
            } else {
              alertify.error(response.message);
            }
          } catch (error) { }
          this.getTourDetails(this.guardTour.id);
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    async getGuardTours() {
      try {
        this.isLoading = true;
        const guardTours = [];
        const response = await this.$axios
          .get("/GuardTour")
          .then(response => {
            response.data.forEach(doc => {
              guardTours.push({
                id: doc.id,
                name: doc.name,
                startDate: doc.startDate
                  ? this.toDateFormat(doc.startDate, "ss:dd")
                  : "",
                endDate: doc.endDate
                  ? this.toDateFormat(doc.endDate, "ss:dd")
                  : ""
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.guardTours = guardTours;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getTourDetails(tourId) {
      try {
        this.isLoading = true;
        const tourDetails = [];
        const response = await this.$axios
          .get("/GuardTour/TourDetails/" + tourId)
          .then(response => {
            response.data.forEach(doc => {
              var cp = {
                name: "",
                areaId: null
              };
              if (doc.guardControlPointId) {
                var cp2 = this.controlPointList.filter(a => {
                  return a.id == doc.guardControlPointId;
                });
              }
              if (cp2[0]) {
                cp = cp2[0];
              }
              tourDetails.push({
                id: doc.id,
                guardTourId: doc.guardTourId,
                guardControlPointId: doc.guardControlPointId,
                time: doc.time ? this.toDateFormat(doc.time, "ss:dd") : "",
                controlPoint: cp
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.tourDetails = tourDetails;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getAreas() {
      try {
        this.isLoading = true;
        const areas = [];
        const response = await this.$axios
          .get("/GuardArea")
          .then(response => {
            response.data.forEach(doc => {
              areas.push({
                id: doc.id,
                areaName: doc.areaName,
                imagePath: doc.imagePath
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.areas = areas;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getControlPoints() {
      try {
        this.isLoading = true;
        const controlPoints = [];
        const response = await this.$axios
          .get("/GuardControlPoint")
          .then(response => {
            response.data.forEach(doc => {
              controlPoints.push({
                id: doc.id,
                areaId: doc.areaId,
                name: doc.name,
                imagePath: doc.imagePath,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.controlPoints = controlPoints;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAreas();
    await this.getControlPoints();
    await this.getGuardTours();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/guardTour/GuardTours.vue